(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["byjove"] = factory();
	else
		root["byjove"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0010":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveCustomerField_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1a60");


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveCustomerField', _ByjoveCustomerField_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveCustomerField_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "00bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/autocomplete/ByjoveAutocomplete.vue?vue&type=template&id=20f9b16d&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-autocomplete',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selected),expression:"!selected"}],ref:"autocomplete",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"field":"label","icon":_vm.icon,"data":_vm.autocompleteData,"open-on-focus":_vm.openOnFocus,"keep-first":""},on:{"typing":_vm.getAsyncData,"select":_vm.selectionMade},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true),model:{value:(_vm.autocompleteValue),callback:function ($$v) {_vm.autocompleteValue=$$v},expression:"autocompleteValue"}}),(_vm.selected)?_c('b-button',{staticStyle:{"width":"100%","justify-content":"left"},on:{"click":function($event){return _vm.clearSelection()}}},[_vm._v("\n    "+_vm._s(_vm.selected.label)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/autocomplete/ByjoveAutocomplete.vue?vue&type=template&id=20f9b16d&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/autocomplete/ByjoveAutocomplete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveAutocompletevue_type_script_lang_js_ = ({
    name: 'ByjoveAutocomplete',
    props: {
        name: String,
        serviceUrl: {
            type: String,
            default: null,
        },
        data: {
            type: Array,
            default: null,
        },
        dataFilter: {
            type: Function,
            default: null,
        },
        value: String,
        initialLabel: String,
        placeholder: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        openOnFocus: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        let selected = null
        if (this.value) {
            selected = {
                value: this.value,
                label: this.initialLabel,
            }
        }
        return {
            fetchedData: [],
            selected: selected,
            isFetching: false,
            autocompleteValue: this.value,
        }
    },

    computed: {

        autocompleteData() {
            return this.serviceUrl ? this.fetchedData : this.filteredData
        },

        filteredData() {
            if (this.dataFilter) {
                return this.data.filter((option) => {
                    return this.dataFilter(this.autocompleteValue, option)
                })
            } else {
                return this.data
            }
        },
    },

    methods: {

        clearSelection() {
            this.selected = null
            this.$emit('input', null)
            this.autocompleteValue = null
            this.$nextTick(function() {
                this.$refs.autocomplete.focus()
            })
        },

        // TODO: i am not clear yet what the best pattern is for setting
        // the selected option.  this does not seem complete but did the
        // trick for what i needed atm..?
        setSelected(option) {
            this.selected = option
        },

        selectionMade(option) {
            this.selected = option
            this.$emit('input', option ? option.value : null)
        },

        // TODO: buefy example uses `debounce()` here and perhaps we should too?
        // https://buefy.org/documentation/autocomplete
        getAsyncData: function (entry) {

            // we only fetch async data via URL if we have one!
            if (!this.serviceUrl) {
                return
            }

            if (entry.length < 3) {
                this.fetchedData = []
                return
            }

            this.isFetching = true
            this.$http.get(this.serviceUrl, {params: {term: entry}}).then((response) => {
                this.fetchedData = response.data
            }).catch((error) => {
                this.fetchedData = []
                throw error
            }).finally(() => {
                this.isFetching = false
            })
        },
    },

});

// CONCATENATED MODULE: ./src/components/autocomplete/ByjoveAutocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var autocomplete_ByjoveAutocompletevue_type_script_lang_js_ = (ByjoveAutocompletevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/autocomplete/ByjoveAutocomplete.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  autocomplete_ByjoveAutocompletevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveAutocomplete = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "00e4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveAutocomplete_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00bd");


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveAutocomplete', _ByjoveAutocomplete_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveAutocomplete_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "0307":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/receiving/ByjoveReceiving.vue?vue&type=template&id=51540a7a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receiving"},[_c('nav',{staticClass:"breadcrumb"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":_vm.getIndexURL()}},[_vm._v("Receiving")])],1),_c('li',[_c('router-link',{attrs:{"to":_vm.getBatchURL()}},[_vm._v(_vm._s(_vm.row.batch_id_str))])],1),_c('li',[_vm._v("\n          "+_vm._s(_vm.row[_vm.productKey])+"\n      ")])])]),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"flex-grow":"1"}},[_c('p',{staticClass:"has-text-weight-bold"},[_vm._v("\n        "+_vm._s(_vm.row.brand_name)+"\n      ")]),_c('p',{staticClass:"has-text-weight-bold"},[_vm._v("\n        "+_vm._s(_vm.row.description)+" "+_vm._s(_vm.row.size)+"\n      ")]),(_vm.allowCases)?_c('p',{staticClass:"has-text-weight-bold"},[_vm._v("\n        1 CS = "+_vm._s(_vm.row.case_quantity || 1)+" "+_vm._s(_vm.row.unit_uom)+"\n      ")]):_vm._e(),_c('table',{staticClass:"receiving-quantities"},[(_vm.row.order_quantities_known)?_c('tr',[_c('td',[_vm._v("ordered")]),_c('td',[(_vm.allowCases)?_c('span',[_vm._v("\n              "+_vm._s(_vm.row.cases_ordered || 0)+" /\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.row.units_ordered || 0)+"\n          ")])]):_vm._e(),(_vm.row.order_quantities_known)?_c('tr',[_c('td',[_vm._v("shipped")]),_c('td',[(_vm.allowCases)?_c('span',[_vm._v("\n              "+_vm._s(_vm.row.cases_shipped || 0)+" /\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.row.units_shipped || 0)+"\n          ")])]):_vm._e(),_c('tr',[_c('td',[_vm._v("received")]),_c('td',[(_vm.allowCases)?_c('span',[_vm._v("\n              "+_vm._s(_vm.row.cases_received || 0)+" /\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.row.units_received || 0)+"\n          ")])]),_c('tr',[_c('td',[_vm._v("damaged")]),_c('td',[(_vm.allowCases)?_c('span',[_vm._v("\n              "+_vm._s(_vm.row.cases_damaged || 0)+" /\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.row.units_damaged || 0)+"\n          ")])]),(_vm.allowExpired)?_c('tr',[_c('td',[_vm._v("expired")]),_c('td',[(_vm.allowCases)?_c('span',[_vm._v("\n              "+_vm._s(_vm.row.cases_expired || 0)+" /\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.row.units_expired || 0)+"\n          ")])]):_vm._e(),_c('tr',[_c('td',[_vm._v("missing")]),_c('td',[(_vm.allowCases)?_c('span',[_vm._v("\n              "+_vm._s(_vm.row.cases_missing || 0)+" /\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.row.units_missing || 0)+"\n          ")])])])]),_c('div',[_c('img',{attrs:{"src":_vm.row.image_url}})])]),(_vm.row.received_alert)?_c('div',{staticClass:"has-text-danger"},[_c('br'),_c('p',[_vm._v(_vm._s(_vm.row.received_alert))])]):_vm._e(),(_vm.row.unexpected_alert)?_c('div',{staticClass:"has-text-danger"},[_c('br'),_c('p',[_vm._v(_vm._s(_vm.row.unexpected_alert))])]):_vm._e(),_vm._t("warnings",null,{"row":_vm.row}),_c('br'),(_vm.shouldShowQuickReceive)?_c('div',[_vm._t("quick-receive",function(){return [_c('div',{staticClass:"buttons"},[(_vm.row.quick_receive_all)?_c('b-button',{attrs:{"type":"is-primary","expanded":""},on:{"click":function($event){return _vm.addQuickAmount(_vm.row.quick_receive_quantity, _vm.row.quick_receive_uom)}}},[_vm._v("\n          "+_vm._s(_vm.row.quick_receive_text)+"\n        ")]):_vm._e(),(!_vm.row.quick_receive_all)?_c('div',[(_vm.allowCases)?_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"type":"is-primary","expanded":""},on:{"click":function($event){return _vm.addQuickAmount(1, 'CS')}}},[_vm._v("\n              Receive 1 CS\n            ")])],1):_vm._e(),_c('div',{staticClass:"buttons has-text-centered",staticStyle:{"width":"100%"}},[_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.addQuickAmount(1, _vm.row.unit_uom)}}},[_vm._v("\n              1 "+_vm._s(_vm.row.unit_uom)+"\n            ")]),_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.addQuickAmount(3, _vm.row.unit_uom)}}},[_vm._v("\n              3 "+_vm._s(_vm.row.unit_uom)+"\n            ")]),_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.addQuickAmount(6, _vm.row.unit_uom)}}},[_vm._v("\n              6 "+_vm._s(_vm.row.unit_uom)+"\n            ")])],1)]):_vm._e()],1)]}),_c('p',{staticClass:"has-text-centered is-italic"},[_vm._v("OR")]),_c('br')],2):_vm._e(),_c('b-field',{attrs:{"grouped":""}},[_c('b-field',{staticClass:"control"},[_c('b-input',{attrs:{"type":"number","custom-class":"receiving-quantity-input"},model:{value:(_vm.inputQuantity),callback:function ($$v) {_vm.inputQuantity=$$v},expression:"inputQuantity"}})],1),_c('b-field',{staticClass:"control"},[_c('b-radio-button',{attrs:{"native-value":"CS","disabled":!_vm.allowCases},model:{value:(_vm.inputUOM),callback:function ($$v) {_vm.inputUOM=$$v},expression:"inputUOM"}},[_c('span',[_vm._v("CS")])]),_c('b-radio-button',{attrs:{"native-value":_vm.row.unit_uom},model:{value:(_vm.inputUOM),callback:function ($$v) {_vm.inputUOM=$$v},expression:"inputUOM"}},[_c('span',[_vm._v(_vm._s(_vm.row.unit_uom))])])],1)],1),_c('b-field',[_c('b-radio-button',{attrs:{"native-value":"received"},model:{value:(_vm.inputType),callback:function ($$v) {_vm.inputType=$$v},expression:"inputType"}},[_c('span',[_vm._v("RCVD")])]),_c('b-radio-button',{attrs:{"native-value":"damaged"},model:{value:(_vm.inputType),callback:function ($$v) {_vm.inputType=$$v},expression:"inputType"}},[_c('span',[_vm._v("DMGD")])]),_c('b-radio-button',{attrs:{"native-value":"expired","disabled":!_vm.allowExpired},model:{value:(_vm.inputType),callback:function ($$v) {_vm.inputType=$$v},expression:"inputType"}},[_c('span',[_vm._v("EXPD")])]),_c('b-radio-button',{attrs:{"native-value":"missing"},model:{value:(_vm.inputType),callback:function ($$v) {_vm.inputType=$$v},expression:"inputType"}},[_c('span',[_vm._v("DNR")])])],1),(_vm.inputType == 'expired')?_c('b-field',{attrs:{"label":"Expiration Date"}},[_c('b-input',{attrs:{"type":"date"},model:{value:(_vm.expirationDate),callback:function ($$v) {_vm.expirationDate=$$v},expression:"expirationDate"}})],1):_vm._e(),_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"type":"is-primary","disabled":_vm.addAmountDisabled},on:{"click":function($event){return _vm.addAmount()}}},[_vm._v("\n      Add Amount\n    ")]),_c('b-button',{attrs:{"type":"is-warning"},on:{"click":function($event){return _vm.subtractAmount()}}},[_vm._v("\n      Subtract Amount\n    ")])],1),_c('p',{staticClass:"has-text-centered is-italic"},[_vm._v("OR")]),_c('br'),_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"type":"is-primary","tag":"router-link","to":("/receiving/rows/" + (_vm.row.uuid))}},[_vm._v("\n      View this Row\n    ")]),_c('b-button',{attrs:{"type":"is-primary","disabled":""}},[_vm._v("\n      Edit this Row\n    ")]),_c('b-button',{attrs:{"type":"is-danger","disabled":""}},[_vm._v("\n      Delete this Row\n    ")])],1)],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/receiving/ByjoveReceiving.vue?vue&type=template&id=51540a7a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/receiving/ByjoveReceiving.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveReceivingvue_type_script_lang_js_ = ({
    name: 'ByjoveReceiving',
    props: {
        productKey: {
            type: String,
            default: 'upc',
        },
        allowCases: {
            type: Boolean,
            default: true,
        },
        allowExpired: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            row: {},
            inputQuantity: 1,
            inputUOM: null,
            inputType: 'received',
            expirationDate: null,
        }
    },

    computed: {
        addAmountDisabled: function() {
            if (this.inputType == 'expired' && !this.expirationDate) {
                return true
            }
            return false
        },
        shouldShowQuickReceive() {
            if (!this.row.quick_receive) {
                return false
            }
            if (!this.row.product_uuid) {
                return false
            }
            return true
        },
    },

    mounted() {
        this.fetch(this.$route.params.uuid)
    },

    methods: {

        getIndexURL() {
            return '/receiving/'
        },

        getBatchURL() {
            return `/receiving/${this.row.batch_uuid}`
        },

        fetch(uuid) {
            this.$http.get(`/api/receiving-batch-row/${uuid}`).then(response => {
                this.row = response.data.data
                if (this.allowCases && this.row.cases_unconfirmed) {
                    this.inputQuantity = this.row.cases_unconfirmed
                    this.inputUOM = 'CS'
                } else {
                    this.inputQuantity = this.row.units_unconfirmed || 1
                    this.inputUOM = this.row.unit_uom
                }
            }, response => {
                if (response.status == 403) { // forbidden; redirect to model index
                    this.$buefy.toast.open({
                        message: "You do not have permission to access that page.",
                        type: 'is-danger',
                    })
                    this.$router.push(this.getIndexURL())
                } else {
                    this.$buefy.toast.open({
                        message: "Failed to fetch page data!",
                        type: 'is-danger',
                    })
                }
            })

        },

        addAmount() {

            let amount = parseInt(this.inputQuantity)
            if (!amount) {
                this.$buefy.toast.open({
                    message: "Please specify an amount",
                    type: 'is-info',
                })
                return
            }

            let url = `/api/receiving-batch-row/${this.row.uuid}/receive`
            let params = {
                row: this.row.uuid,
                mode: this.inputType,
                cases: null,
                units: null,
                expiration_date: this.expirationDate,
                quick_receive: false,
            }

            if (this.inputUOM == 'CS') {
                params.cases = amount
            } else {
                params.units = amount
            }

            this.$http.post(url, params).then(response => {
                if (response.data.data) {
                    this.$router.push(`/receiving/${this.row.batch_uuid}`)
                } else {
                    this.$buefy.toast.open({
                        message: response.data.error || "Failed to post receiving!",
                        type: 'is-danger',
                    })
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "Failed to post receiving!",
                    type: 'is-danger',
                })
            })
        },

        addQuickAmount(quantity, uom) {
            this.inputQuantity = quantity
            this.inputUOM = uom
            this.addAmount()
        },

        subtractAmount() {
            this.inputQuantity = -this.inputQuantity
            this.addAmount()
        },
    },
});

// CONCATENATED MODULE: ./src/components/receiving/ByjoveReceiving.vue?vue&type=script&lang=js&
 /* harmony default export */ var receiving_ByjoveReceivingvue_type_script_lang_js_ = (ByjoveReceivingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/receiving/ByjoveReceiving.vue?vue&type=style&index=0&lang=css&
var ByjoveReceivingvue_type_style_index_0_lang_css_ = __webpack_require__("700d");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/receiving/ByjoveReceiving.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  receiving_ByjoveReceivingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveReceiving = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "04d0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/app/ByjoveApp.vue?vue&type=template&id=05a37176&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.session_established),expression:"$store.state.session_established"}],staticClass:"main-container"},[_vm._t("default",function(){return [_c('p',[_vm._v("TODO: put your nav in the default slot!")])]}),_c('div',{staticClass:"page-content-wrapper"},[_c('div',{staticClass:"page-content"},[_c('router-view')],1)]),(_vm.includeFooter)?_c('footer',{staticClass:"footer"},[_vm._t("footer",function(){return [_c('router-link',{attrs:{"to":"/about"}},[_vm._v(_vm._s(_vm.appsettings.appTitle)+" "+_vm._s(_vm.appsettings.version))])]})],2):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/app/ByjoveApp.vue?vue&type=template&id=05a37176&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/app/ByjoveApp.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveAppvue_type_script_lang_js_ = ({
    name: 'ByjoveApp',
    props: {
        appsettings: Object,
        includeFooter: {
            type: Boolean,
            default: true,
        },
    },
    beforeCreate: function() {

        // TODO: even with beforeCreate() this logic is still happening "too
        // slowly" for us to reliably check perms on first page load,
        // i.e. after browser refresh.  maybe can avoid async for the GET?

        // when main app is first created, fetch user session data from
        // backend; this will tell us who the user is (or if they're not yet
        // logged in) which in turn is used to control which features are
        // exposed.  also this gives us the XSRF token cookie from the server.
        // TODO: make this API URL configurable, somehow..?
        this.$http.get('/api/session').then(response => {

            // let all of app know who the user is(n't)
            this.$store.commit('SET_USER', response.data.user || {})
            this.$store.commit('SET_USER_IS_ADMIN', response.data.user ? response.data.user.is_admin : false)
            this.$store.commit('SET_USER_IS_ROOT', response.data.user ? response.data.user.is_root : false)

            // also keep track of user's permissions
            this.$store.commit('SET_PERMISSIONS', response.data.permissions)

            // also keep track of backend app settings
            this.$store.commit('SET_SETTINGS', response.data.settings || {})

            // declare the session established
            this.$store.commit('SET_SESSION_ESTABLISHED', true)

            // set background color, to whatever api said
            // TODO: should this be the custom app's responsibility?
            if (response.data.background_color) {
                document.body.style.backgroundColor = response.data.background_color
            }
        })
    },
    mounted: function () {

        // add "testing" watermark unless running in production mode
        // if (!appsettings.production) {
        if (!this.appsettings.production) {
            // document.body.style.backgroundImage = appsettings.watermark;
            document.body.style.backgroundImage = this.appsettings.watermark;
        }
    }
});

// CONCATENATED MODULE: ./src/components/app/ByjoveApp.vue?vue&type=script&lang=js&
 /* harmony default export */ var app_ByjoveAppvue_type_script_lang_js_ = (ByjoveAppvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/app/ByjoveApp.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  app_ByjoveAppvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveApp = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "10dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveHome_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ec50");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveHome', _ByjoveHome_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveHome_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "126b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/login/ByjoveLogin.vue?vue&type=template&id=dcd772a6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"byjove-login"},[_c('form',[_c('byjove-logo',{attrs:{"centered":"","appsettings":_vm.appsettings}}),_c('b-field',{attrs:{"label":"Username"}},[_c('b-input',{model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_c('b-field',{attrs:{"label":"Password"}},[_c('b-input',{attrs:{"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),(_vm.loginError)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("\n      "+_vm._s(_vm.loginError)+"\n    ")]):_vm._e(),_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"type":"is-primary","disabled":_vm.loginFormDisabled,"expanded":""},on:{"click":function($event){return _vm.attemptLogin()}}},[_vm._v("\n        Login\n      ")])],1)],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/login/ByjoveLogin.vue?vue&type=template&id=dcd772a6&

// EXTERNAL MODULE: ./src/components/logo/index.js
var logo = __webpack_require__("934a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/login/ByjoveLogin.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ByjoveLoginvue_type_script_lang_js_ = ({
    name: 'ByjoveLogin',
    components: {
        ByjoveLogo: logo["a" /* default */],
    },
    props: {
        appsettings: Object,
    },
    data() {
        return {
            inited: false,
            username: null,
            password: null,
            loginError: null,
        }
    },
    computed: {

        loginFormDisabled: function() {
            if (!this.username) {
                return true
            } else if (!this.password) {
                return true
            }
            return false
        },

    },
    created() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            if (this.inited) return

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            this.inited = true

            // send logged-in users to "home" page
            if (this.$store.state.user.uuid) {
                this.$router.push('/')
            }
        },

        attemptLogin() {

            // clear any previous login error
            this.loginError = null

            // post credentials to login API
            let creds = {
                username: this.username,
                password: this.password,
            }
            this.$http.post('/api/login', creds).then(response => {
                if (response.data.ok) {

                    // login successful; let the app know
                    this.$byjoveLoginUser(response.data.user,
                                          response.data.permissions)

                    // send user to "home" page
                    this.$router.push('/')

                } else {
                    // login failed
                    this.loginError = response.data.error;
                }
            })
        },

    },
});

// CONCATENATED MODULE: ./src/components/login/ByjoveLogin.vue?vue&type=script&lang=js&
 /* harmony default export */ var login_ByjoveLoginvue_type_script_lang_js_ = (ByjoveLoginvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/login/ByjoveLogin.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  login_ByjoveLoginvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveLogin = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "17d7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menu/ByjoveMenu.vue?vue&type=template&id=2c07bdac&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('nav',{staticClass:"level is-mobile"},[(_vm.user.uuid)?_c('div',{staticClass:"level-item"},[_c('b-dropdown',{attrs:{"aria-role":"menu"}},[_c('b-button',{class:{'is-danger': _vm.exposeRoot && _vm.user_is_root},attrs:{"slot":"trigger","type":"is-primary","icon-left":"user","icon-right":"angle-down"},slot:"trigger"},[_vm._v("\n          "+_vm._s(_vm.user.short_name)+"\n        ")]),_vm._t("default"),(_vm.exposeRoot && _vm.$store.state.user_is_admin && !_vm.user_is_root)?_c('b-dropdown-item',{staticClass:"root-user",attrs:{"aria-role":"menuitem","has-link":""}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.becomeRoot()}}},[_vm._v("Become root")])]):_vm._e(),(_vm.exposeRoot && _vm.user_is_root)?_c('b-dropdown-item',{staticClass:"root-user",attrs:{"aria-role":"menuitem","has-link":""}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.stopRoot()}}},[_vm._v("Stop being root")])]):_vm._e(),_c('b-dropdown-item',{attrs:{"aria-role":"menuitem","has-link":""}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout()}}},[_vm._v("Logout")])]),(_vm.includeAboutLink)?_c('b-dropdown-item',{attrs:{"aria-role":"menuitem","has-link":""}},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1):_vm._e()],2)],1):_vm._e(),(!_vm.user.uuid && _vm.showLoginButton)?_c('div',{staticClass:"level-item"},[_c('b-button',{attrs:{"type":"is-primary","tag":"router-link","to":"/login"}},[_c('b-icon',{attrs:{"icon":"fas fa-user"}}),_c('span',[_vm._v("Login")])],1)],1):_vm._e(),_c('div',{staticClass:"level-item"},[_vm._t("header",function(){return [_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]})],2),(_vm.shouldShowFeedback)?_c('div',{staticClass:"level-item"},[_c('byjove-feedback',{attrs:{"url":_vm.feedbackUrl,"recipient-options":_vm.feedbackRecipientOptions}})],1):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/menu/ByjoveMenu.vue?vue&type=template&id=2c07bdac&

// EXTERNAL MODULE: ./src/components/feedback/index.js
var feedback = __webpack_require__("4275");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/menu/ByjoveMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ByjoveMenuvue_type_script_lang_js_ = ({
    name: 'ByjoveMenu',
    props: {
        appsettings: Object,
        showLoginButton: {
            type: Boolean,
            default: true,
        },
        logoutUrl: {
            type: String,
            default: '/api/logout',
        },
        allowFeedback: {
            type: Boolean,
            default: null,
        },
        allowAnonymousFeedback: {
            type: Boolean,
            default: false,
        },
        feedbackUrl: {
            type: String,
            default: '/api/feedback',
        },
        feedbackRecipientOptions: {
            type: Array,
            default: null,
        },
        includeAboutLink: {
            type: Boolean,
            default: true,
        },
        exposeRoot: {
            type: Boolean,
            default: true,
        },
        becomeRootUrl: {
            type: String,
            default: '/api/become-root',
        },
        stopRootUrl: {
            type: String,
            default: '/api/stop-root',
        },
    },
    components: {
        ByjoveFeedback: feedback["a" /* default */],
    },
    computed: {
        title: function() {
            if (this.appsettings.production) {
                return this.appsettings.systemTitle
            } else {
                return "[STAGE] " + this.appsettings.systemTitle
            }
        },
        user: function() {
            return this.$store.state.user
        },
        user_is_root: function() {
            return this.$store.state.user_is_root
        },
        shouldShowFeedback: function() {
            if (this.allowFeedback !== null) {
                return this.allowFeedback
            }
            if (!this.allowAnonymousFeedback && !this.user.uuid) {
                return false
            }
            return true
        },
    },
    methods: {

        logout() {
            // submit user logout request to backend
            this.$http.post(this.logoutUrl).then(response => {

                // do logout proper, within our app
                this.$logoutUser()

                // re-fetch session to get fresh XSRF token cookie; our http
                // interceptor will handle the rest of that for us.  once we
                // have token we show the login form again
                this.$http.get('/api/session').then(response => {
                    this.$router.push('/login')
                })
            })
        },

        becomeRoot() {
            if (this.user_is_root || !this.$store.state.user_is_admin) {
                return
            }
            this.$http.post(this.becomeRootUrl).then(response => {
                this.$store.commit('SET_USER_IS_ROOT', true)
                this.$buefy.toast.open({
                    message: "You have been elevated to 'root' and now have full system access",
                    type: 'is-success',
                })
            }, response => {
                this.$buefy.toast.open({
                    message: "Something went wrong!",
                    type: 'is-danger',
                })
            })

        },
        stopRoot() {
            if (!this.user_is_root) {
                return
            }
            this.$http.post(this.stopRootUrl).then(response => {
                this.$store.commit('SET_USER_IS_ROOT', false)
                this.$buefy.toast.open({
                    message: "Your normal system access has been restored",
                    type: 'is-success',
                })
            }, response => {
                this.$buefy.toast.open({
                    message: "Something went wrong!",
                    type: 'is-danger',
                })
            })
        },
    },
});

// CONCATENATED MODULE: ./src/components/menu/ByjoveMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var menu_ByjoveMenuvue_type_script_lang_js_ = (ByjoveMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/menu/ByjoveMenu.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  menu_ByjoveMenuvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveMenu = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "19ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/feedback/ByjoveFeedback.vue?vue&type=template&id=e45e3476&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"type":"is-primary","icon-left":"fas fa-comment"},on:{"click":function($event){return _vm.showFeedback()}}},[_vm._v("\n    Feedback\n  ")]),_c('b-modal',{attrs:{"has-modal-card":"","active":_vm.showFeedbackDialog},on:{"update:active":function($event){_vm.showFeedbackDialog=$event}}},[_c('div',{staticClass:"modal-card"},[_c('section',{staticClass:"modal-card-body"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("User Feedback")]),_c('br'),(_vm.hasRecipientOptions)?_c('div',[_c('p',{staticClass:"block"},[_vm._v("\n            Comments welcome!  Just let us know who they should go to.\n          ")]),_c('b-field',{attrs:{"label":"Who To Notify?","type":_vm.recipient ? null : 'is-danger'}},[_c('b-select',{model:{value:(_vm.recipient),callback:function ($$v) {_vm.recipient=$$v},expression:"recipient"}},_vm._l((_vm.allRecipientOptions),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                "+_vm._s(option.label)+"\n              ")])}),0)],1)],1):_vm._e(),(!_vm.hasRecipientOptions)?_c('div',[_c('p',[_vm._v("\n            Questions, suggestions, comments, complaints, etc. regarding this\n            website are welcome and may be submitted below.\n          ")]),_c('b-field',{attrs:{"label":"Referring URL"}},[_c('div',{staticClass:"control"},[_vm._v("\n              "+_vm._s(_vm.referringURL)+"\n            ")])])],1):_vm._e(),_c('b-field',{directives:[{name:"show",rawName:"v-show",value:(!_vm.userUUID),expression:"!userUUID"}],attrs:{"label":"Your Name"}},[_c('b-input',{model:{value:(_vm.userName),callback:function ($$v) {_vm.userName=$$v},expression:"userName"}})],1),_c('b-field',{attrs:{"label":"Message"}},[_c('b-input',{attrs:{"type":"textarea"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_c('div',{staticClass:"buttons"},[_c('b-button',{on:{"click":function($event){return _vm.cancelFeedback()}}},[_vm._v("\n            Cancel\n          ")]),_c('b-button',{attrs:{"type":"is-primary","disabled":_vm.sendIsDisabled},on:{"click":function($event){return _vm.sendFeedback()}}},[_vm._v("\n            Send Note\n          ")])],1)],1)])])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/feedback/ByjoveFeedback.vue?vue&type=template&id=e45e3476&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/feedback/ByjoveFeedback.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveFeedbackvue_type_script_lang_js_ = ({
    name: 'ByjoveFeedback',
    props: {
        url: String,
        // userUUID: String,
        // user: Object,
        recipientOptions: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            showFeedbackDialog: false,
            referringURL: null,
            recipient: null,
            userUUID: null,
            userName: null,
            message: null,
        }
    },
    computed: {
        allRecipientOptions() {
            if (this.recipientOptions !== null) {
                return this.recipientOptions
            }
            return []
        },
        hasRecipientOptions() {
            return !!this.allRecipientOptions.length
        },
        sendIsDisabled() {
            if (this.hasRecipientOptions && !this.recipient) {
                return true
            }
            if (!this.message) {
                return true
            }
            return false
        },
    },
    methods: {

        clearForm() {
            this.recipient = null
            this.message = null
        },

        showFeedback() {
            this.referringURL = location.href
            if (this.$store.state.user) {
                this.userUUID = this.$store.state.user.uuid
            }
            this.showFeedbackDialog = true
        },

        cancelFeedback() {
            this.showFeedbackDialog = false
            // this.clearForm()
        },

        sendFeedback() {
            let params = {
                email_key: this.recipient,
                referrer: this.referringURL,
                user: this.userUUID,
                // user: this.user ? this.user.uuid : null,
                user_name: this.userName,
                message: this.message,
            }
            this.$http.post(this.url, params).then(response => {
                this.showFeedbackDialog = false
                this.clearForm()
                this.$buefy.toast.open({
                    message: "Thank you for your feedback!",
                    type: 'is-success',
                })
            }, response => {
                this.$buefy.toast.open({
                    message: "Something went wrong!",
                    type: 'is-danger',
                })
            })
        },
    },

});

// CONCATENATED MODULE: ./src/components/feedback/ByjoveFeedback.vue?vue&type=script&lang=js&
 /* harmony default export */ var feedback_ByjoveFeedbackvue_type_script_lang_js_ = (ByjoveFeedbackvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/feedback/ByjoveFeedback.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  feedback_ByjoveFeedbackvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveFeedback = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1a60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/customers/ByjoveCustomerField.vue?vue&type=template&id=1085946a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":_vm.label,"expanded":"","type":_vm.fieldType}},[(!_vm.readonly && !_vm.useDropdown)?_c('byjove-autocomplete',{ref:"autocomplete",attrs:{"service-url":_vm.autocompleteUrl},on:{"input":_vm.customerChanged},model:{value:(_vm.customerUUID),callback:function ($$v) {_vm.customerUUID=$$v},expression:"customerUUID"}}):_vm._e(),(!_vm.readonly && _vm.useDropdown)?_c('b-select',{on:{"input":_vm.customerChanged},model:{value:(_vm.customerUUID),callback:function ($$v) {_vm.customerUUID=$$v},expression:"customerUUID"}},_vm._l((_vm.customers),function(customer){return _c('option',{key:customer.uuid,domProps:{"value":customer.uuid}},[_vm._v("\n      "+_vm._s(customer.name)+"\n    ")])}),0):_vm._e(),(_vm.readonly)?_c('router-link',{attrs:{"to":("/customers/" + _vm.value)}},[_vm._v("\n    "+_vm._s(_vm.readonlyDisplay || _vm.value)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/customers/ByjoveCustomerField.vue?vue&type=template&id=1085946a&

// EXTERNAL MODULE: ./src/components/autocomplete/index.js
var autocomplete = __webpack_require__("00e4");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/customers/ByjoveCustomerField.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ByjoveCustomerFieldvue_type_script_lang_js_ = ({
    name: 'ByjoveCustomerField',

    components: {
        ByjoveAutocomplete: autocomplete["a" /* default */],
    },

    props: {
        name: {
            type: String,
        },
        label: {
            type: String,
            default: "Customer",
        },
        value: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        readonlyDisplay: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        dropdown: {
            type: Boolean,
            default: null,
        },
        autocompleteUrl: {
            type: String,
            // TODO: should not hard-code the "full" api endpoint url here
            default: '/api/customers/autocomplete',
        },
    },

    data() {
        return {
            inited: false,
            customerUUID: null,
            customers: [],
        }
    },

    computed: {

        fieldType() {
            if (this.required && !this.customerUUID) {
                return 'is-danger'
            }
        },

        useDropdown() {

            // use whatever caller specified, if they did so
            if (this.dropdown !== null) {
                return this.dropdown
            }

            // use setting, provided session is loaded
            if (this.$store.state.session_established) {
                return this.$store.state.settings['customer_field_dropdown']
            }

            // otherwise assume false by default
            return false
        },

    },

    created() {
        this.init()
    },

    watch: {
        '$store.state.session_established': 'init',
    },

    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            this.inited = true

            // fetch any needed data
            this.fetchData()
        },

        fetchData() {

            // nothing to fetch if not using dropdown
            if (!this.useDropdown) {
                return
            }

            // get all customers for dropdown
            this.$http.get('/api/customers?sort=name|asc').then(response => {
                this.customers = response.data.customers
            })
        },

        customerChanged(value) {
            this.$emit('input', value)
        },

        setCustomer(customer) {
            this.$refs.autocomplete.selectionMade({
                value: customer.uuid,
                label: customer._str,
            })
        },

    },

});

// CONCATENATED MODULE: ./src/components/customers/ByjoveCustomerField.vue?vue&type=script&lang=js&
 /* harmony default export */ var customers_ByjoveCustomerFieldvue_type_script_lang_js_ = (ByjoveCustomerFieldvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/customers/ByjoveCustomerField.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  customers_ByjoveCustomerFieldvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveCustomerField = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1f02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveScannerInput_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("21c3");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveScannerInput', _ByjoveScannerInput_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveScannerInput_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "20b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/logo/ByjoveLogo.vue?vue&type=template&id=219f645c&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"byjove-logo",style:(_vm.centered ? 'text-align: center;' : null)},[(_vm.appsettings.logo)?_c('img',{attrs:{"alt":_vm.alternateText,"src":_vm.appsettings.logo}}):_vm._e(),(!_vm.appsettings.logo)?_c('img',{attrs:{"alt":_vm.alternateText,"src":__webpack_require__("cf05")}}):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/logo/ByjoveLogo.vue?vue&type=template&id=219f645c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/logo/ByjoveLogo.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveLogovue_type_script_lang_js_ = ({
    name: 'ByjoveLogo',
    props: {
        appsettings: Object,
        centered: Boolean,
    },
    computed: {
        alternateText: function() {
            return this.appsettings.systemTitle + " logo"
        },
    },
});

// CONCATENATED MODULE: ./src/components/logo/ByjoveLogo.vue?vue&type=script&lang=js&
 /* harmony default export */ var logo_ByjoveLogovue_type_script_lang_js_ = (ByjoveLogovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/logo/ByjoveLogo.vue?vue&type=style&index=0&id=219f645c&scoped=true&lang=css&
var ByjoveLogovue_type_style_index_0_id_219f645c_scoped_true_lang_css_ = __webpack_require__("ae81");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/logo/ByjoveLogo.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  logo_ByjoveLogovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "219f645c",
  null
  
)

/* harmony default export */ var ByjoveLogo = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "21c3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/scanner-input/ByjoveScannerInput.vue?vue&type=template&id=43bc51c1&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scanner-input"},[_c('b-input',{attrs:{"placeholder":"Scan/Enter Code","icon":"search"},nativeOn:{"keypress":function($event){return _vm.quickKey.apply(null, arguments)}},model:{value:(_vm.quickEntry),callback:function ($$v) {_vm.quickEntry=$$v},expression:"quickEntry"}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/scanner-input/ByjoveScannerInput.vue?vue&type=template&id=43bc51c1&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/scanner-input/ByjoveScannerInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveScannerInputvue_type_script_lang_js_ = ({
    name: 'ByjoveScannerInput',
    data() {
        return {
            quickEntry: '',
        }
    },
    mounted() {
        window.addEventListener('keypress', this.globalKey)
    },
    beforeDestroy() {
        window.removeEventListener('keypress', this.globalKey)
    },

    methods: {

        clear() {
            this.quickEntry = ''
        },

        globalKey(event) {
            if (event.target.tagName == 'BODY') {

                // mimic keyboard wedge
                if (event.charCode >= 48 && event.charCode <= 57) { // numeric (qwerty)
                    this.$nextTick(() => {
                        this.quickEntry += event.key
                    })

                } else if (event.keyCode == 13) { // enter
                    this.submitQuickEntry()
                }
            }
        },

        quickKey(event) {
            if (event.keyCode == 13) { // enter
                this.submitQuickEntry()
            }
        },

        submitQuickEntry() {
            if (this.quickEntry) {
                this.$emit('submit', this.quickEntry)
            }
        },
    },
});

// CONCATENATED MODULE: ./src/components/scanner-input/ByjoveScannerInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var scanner_input_ByjoveScannerInputvue_type_script_lang_js_ = (ByjoveScannerInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/scanner-input/ByjoveScannerInput.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  scanner_input_ByjoveScannerInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveScannerInput = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "22a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveModelCrud_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5113");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveModelCrud', _ByjoveModelCrud_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveModelCrud_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "3691":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/model-index/ByjoveModelIndex.vue?vue&type=template&id=52452168&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-index",class:_vm.getModelSlug()},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_c('li',[_vm._v(_vm._s(_vm.getModelIndexTitle()))])])]),(_vm.allowCreate && _vm.userCanCreate())?_c('div',{staticClass:"buttons block"},[_c('b-button',{staticClass:"new-object",attrs:{"type":"is-primary","tag":"router-link","to":_vm.getModelPathPrefix() + '/new',"icon-left":"plus"}},[_vm._v("\n      New "+_vm._s(_vm.getModelTitle())+"\n    ")])],1):_vm._e(),_vm._t("default"),_c('b-menu',[_c('b-menu-list',_vm._l((_vm.data.data),function(obj){return _c('b-menu-item',{key:obj.uuid,attrs:{"label":_vm.renderLabel(obj),"tag":_vm.hasModelPerm('view') ? 'router-link' : 'a',"to":_vm.getModelPathPrefix() + '/' + obj.uuid}})}),1)],1),(_vm.paginated)?_c('b-pagination',{attrs:{"total":_vm.data.total,"current":_vm.page,"per-page":_vm.perPage},on:{"update:current":function($event){_vm.page=$event},"change":_vm.changePagination}}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/model-index/ByjoveModelIndex.vue?vue&type=template&id=52452168&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/model-index/ByjoveModelIndex.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveModelIndexvue_type_script_lang_js_ = ({
    name: 'ByjoveModelIndex',
    props: {
        modelName: String,
        modelSlug: String,
        modelTitle: String,
        modelTitlePlural: String,
        modelIndexTitle: String,
        modelPermissionPrefix: String,
        modelPathPrefix: String,
        labelRenderer: Function,
        apiIndexUrl: String,
        apiIndexSort: [Array, Object],
        apiIndexFilters: Array,
        nativeSort: {
            type: Boolean,
            default: false,
        },
        wantInitialResults: {
            type: Boolean,
            default: true,
        },
        allowCreate: {
            type: Boolean,
            default: true,
        },
        createPermCheck: Function,
        paginated: {
            type: Boolean,
            default: true,
        },
        perPage: {
            type: Number,
            default: 20,
        },
    },
    data: function() {
        return {
            data: {},
            page: 1,
        }
    },
    mounted() {
        if (this.wantInitialResults) {
            this.fetchData()
        }
    },
    watch: {
        'apiIndexFilters' (to, from) {
            this.fetchData()
        },
    },
    methods: {

        changePagination(value) {
            this.fetchData()
        },

        fetchData() {
            let params = {
                filters: JSON.stringify(this.apiIndexFilters),
            }
            if (this.nativeSort) {
                params.nativeSort = JSON.stringify(this.apiIndexSort)
            } else {
                params.orderBy = this.apiIndexSort.field
                params.ascending = (this.apiIndexSort.dir == 'asc') ? 1 : 0
            }
            if (this.paginated) {
                params.per_page = this.perPage
                params.page = this.page || 1
            }
            this.$http.get(this.getApiIndexUrl(), {params: params}).then(response => {
                this.data = response.data

            }, response => {
                if (response.status == 403) { // forbidden; redirect to home page
                    this.$buefy.toast.open({
                        message: "You do not have permission to access that page.",
                        type: 'is-danger',
                    })
                    this.$router.push('/')
                } else if (response.status == 404) { // not found; display warning
                    this.$buefy.toast.open({
                        message: "Page data not found!",
                        type: 'is-danger',
                    })
                } else {
                    this.$buefy.toast.open({
                        message: "Failed to fetch page data!",
                        type: 'is-danger',
                    })
                }
            })
        },

        getModelSlug() {
            if (this.modelSlug) {
                return this.modelSlug
            }
            return this.modelName.toLowerCase() + 's'
        },

        getModelTitle() {
            if (this.modelTitle) {
                return this.modelTitle
            }
            return this.modelName
        },

        getModelTitlePlural() {
            if (this.modelTitlePlural) {
                return this.modelTitlePlural
            }
            return this.getModelTitle() + 's'
        },

        getModelIndexTitle() {
            if (this.modelIndexTitle) {
                return this.modelIndexTitle
            }
            return this.getModelTitlePlural()
        },

        getModelPathPrefix() {
            if (this.modelPathPrefix) {
                return this.modelPathPrefix
            }
            return '/' + this.getModelSlug()
        },

        getApiIndexUrl() {
            if (this.apiIndexUrl) {
                return this.apiIndexUrl
            }
            return '/api/' + this.getModelSlug()
        },

        getModelPermissionPrefix() {
            if (this.modelPermissionPrefix) {
                return this.modelPermissionPrefix
            }
            return this.getModelSlug()
        },

        userCanCreate() {
            if (this.createPermCheck) {
                return this.createPermCheck()
            }
            return this.hasModelPerm('create')
        },

        hasModelPerm(perm) {

            // do normal check, but first add prefix
            let prefix = this.getModelPermissionPrefix()
            return this.$hasPerm(prefix + '.' + perm)
        },

        renderLabel(obj) {
            if (this.labelRenderer) {
                return this.labelRenderer(obj)
            }
            return obj._str
        },
    },
});

// CONCATENATED MODULE: ./src/components/model-index/ByjoveModelIndex.vue?vue&type=script&lang=js&
 /* harmony default export */ var model_index_ByjoveModelIndexvue_type_script_lang_js_ = (ByjoveModelIndexvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/model-index/ByjoveModelIndex.vue?vue&type=style&index=0&lang=css&
var ByjoveModelIndexvue_type_style_index_0_lang_css_ = __webpack_require__("7d4a");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/model-index/ByjoveModelIndex.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  model_index_ByjoveModelIndexvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveModelIndex = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "3f64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inventory/ByjoveInventory.vue?vue&type=template&id=26ea81cf&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory"},[_c('nav',{staticClass:"breadcrumb"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":_vm.getIndexUrl()}},[_vm._v("\n          Inventory\n        ")])],1),_c('li',[_c('router-link',{attrs:{"to":_vm.getBatchUrl()}},[_vm._v("\n          "+_vm._s(_vm.row.batch_id_str)+"\n        ")])],1),_c('li',[_vm._v("\n          "+_vm._s(_vm.row[_vm.productKey])+"\n      ")])])]),_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"flex-grow":"1"}},[_c('p',{staticClass:"has-text-weight-bold"},[_vm._v("\n        "+_vm._s(_vm.row.brand_name)+"\n      ")]),_c('p',{staticClass:"has-text-weight-bold"},[_vm._v("\n        "+_vm._s(_vm.row.description)+" "+_vm._s(_vm.row.size)+"\n      ")]),_c('p',{staticClass:"has-text-weight-bold"},[_c('br'),_vm._v("\n        1 CS = "+_vm._s(_vm.row.case_quantity || 1)+" "+_vm._s(_vm.row.unit_uom)+"\n      ")])]),_c('div',[_c('img',{attrs:{"src":_vm.row.image_url}})])]),_c('b-field',{attrs:{"grouped":""}},[_c('b-field',{attrs:{"label":"Cases","expanded":""}},[_c('b-input',{attrs:{"type":"number","step":"any","disabled":!_vm.shouldAllowCases()},model:{value:(_vm.row.cases),callback:function ($$v) {_vm.$set(_vm.row, "cases", $$v)},expression:"row.cases"}})],1),_c('b-field',{attrs:{"label":"Units","expanded":""}},[_c('b-input',{attrs:{"type":"number","step":"any"},model:{value:(_vm.row.units),callback:function ($$v) {_vm.$set(_vm.row, "units", $$v)},expression:"row.units"}})],1)],1),_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"type":"is-primary","icon-left":"save"},on:{"click":function($event){return _vm.saveCounts()}}},[_vm._v("\n      Save Counts\n    ")]),_c('b-button',{attrs:{"tag":"router-link","to":("/inventory/rows/" + (_vm.row.uuid))}},[_vm._v("\n      Cancel\n    ")])],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/inventory/ByjoveInventory.vue?vue&type=template&id=26ea81cf&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/inventory/ByjoveInventory.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveInventoryvue_type_script_lang_js_ = ({
    name: 'ByjoveInventory',
    props: {
        productKey: {
            type: String,
            default: 'upc_pretty',
        },
        allowCases: {
            type: Boolean,
            default: true,
        },
        allowEdit: {
            type: Boolean,
            default: false,
        },
        allowDelete: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            row: {},
        }
    },

    created() {
        this.fetch(this.$route.params.uuid)
    },

    methods: {

        getIndexUrl() {
            return '/inventory/'
        },

        getBatchUrl() {
            return `/inventory/${this.row.batch_uuid}`
        },

        getViewUrl() {
            return `/inventory/rows/${this.row.uuid}`
        },

        getDeleteUrl() {
            return `/inventory/rows/${this.row.uuid}/delete`
        },

        getApiUrl(uuid) {
            if (!uuid) {
                uuid = this.row.uuid
            }
            return `/api/inventory-batch-row/${uuid}`
        },

        shouldAllowCases() {
            if (!this.allowCases) {
                return false
            }
            return this.row.allow_cases
        },

        shouldAllowEdit() {
            if (!this.allowEdit) {
                return false
            }
            return true
        },

        shouldAllowDelete() {
            if (!this.allowDelete) {
                return false
            }
            return true
        },

        fetch(uuid) {
            let url = this.getApiUrl(uuid)
            this.$http.get(url).then(response => {
                this.row = response.data.data
                if (this.row.batch_executed || this.row.batch_complete) {
                    // cannot edit this row, so view it instead
                    this.$router.push(this.getViewUrl())
                }
            }, response => {
                if (response.status == 403) { // forbidden; redirect to model index
                    this.$buefy.toast.open({
                        message: "You do not have permission to access that page.",
                        type: 'is-danger',
                    })
                    this.$router.push(this.getIndexUrl())
                } else {
                    this.$buefy.toast.open({
                        message: "Failed to fetch page data!",
                        type: 'is-danger',
                    })
                }
            })

        },

        saveCounts() {
            let url = this.getApiUrl()
            let params = {
                row: this.row.uuid,
                units: this.row.units,
            }
            if (this.shouldAllowCases()) {
                params.cases = this.row.cases
            }
            this.$http.post(url, params).then(response => {
                if (response.data.data) {
                    // return to batch view
                    this.$router.push(this.getBatchUrl())
                } else {
                    this.$buefy.toast.open({
                        message: response.data.error || "Failed to save counts!",
                        type: 'is-danger',
                    })
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "Failed to save counts (server error)!",
                    type: 'is-danger',
                })
            })
        },
    },
});

// CONCATENATED MODULE: ./src/components/inventory/ByjoveInventory.vue?vue&type=script&lang=js&
 /* harmony default export */ var inventory_ByjoveInventoryvue_type_script_lang_js_ = (ByjoveInventoryvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/inventory/ByjoveInventory.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  inventory_ByjoveInventoryvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveInventory = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "418e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4275":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveFeedback_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("19ff");
// import ByjoveFeedback from './ByjoveFeedback'

// Import vue component
// import component from './ByjoveFeedback';


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveFeedback', _ByjoveFeedback_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
// export default component;
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveFeedback_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "4395":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveLogin_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("126b");


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveLogin', _ByjoveLogin_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveLogin_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "4945":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveModelIndex_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3691");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveModelIndex', _ByjoveModelIndex_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveModelIndex_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5113":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/model-crud/ByjoveModelCrud.vue?vue&type=template&id=7077082e&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"model-crud",class:_vm.getModelSlug()},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":_vm.getModelPathPrefix() + '/'}},[_vm._v(_vm._s(_vm.getModelIndexTitle()))])],1),(_vm.isRow)?_c('li',[_c('router-link',{attrs:{"to":_vm.getParentUrl()}},[_vm._v(_vm._s(_vm.renderParentHeaderLabel(_vm.record)))])],1):_vm._e(),(_vm.mode == 'creating')?_c('li',[_vm._v("\n          New\n      ")]):_vm._e(),(_vm.mode == 'viewing')?_c('li',[_vm._v("\n          "+_vm._s(_vm.renderHeaderLabel(_vm.record))+"\n      ")]):_vm._e(),(_vm.mode == 'editing' || _vm.mode == 'executing' || _vm.mode == 'deleting')?_c('li',[_c('router-link',{attrs:{"to":_vm.getViewURL()}},[_vm._v("\n          "+_vm._s(_vm.renderHeaderLabel(_vm.record))+"\n        ")])],1):_vm._e(),(_vm.mode == 'editing')?_c('li',[_vm._v("\n          Edit\n      ")]):_vm._e(),(_vm.mode == 'executing')?_c('li',[_vm._v("\n          Execute\n      ")]):_vm._e(),(_vm.mode == 'deleting')?_c('li',[_vm._v("\n          Delete\n      ")]):_vm._e()])]),_vm._t("default"),(_vm.showButtons)?_c('div',{staticClass:"buttons",staticStyle:{"margin-top":"1rem"}},[(!_vm.hideSaveButton)?_c('b-button',{attrs:{"type":_vm.getSaveButtonType(),"icon-left":_vm.getSaveButtonIcon(),"disabled":_vm.saveDisabled},on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      "+_vm._s(_vm.getSaveButtonText())+"\n    ")]):_vm._e(),_c('b-button',{attrs:{"tag":"router-link","to":_vm.getCancelURL()}},[_vm._v("\n      Cancel\n    ")])],1):_vm._e(),(_vm.shouldAllowEdit() || _vm.shouldAllowDelete())?_c('div',{staticClass:"buttons"},[_c('br'),_c('br'),(_vm.shouldAllowEdit())?_c('b-button',{attrs:{"type":"is-primary","icon-left":"edit","tag":"router-link","to":_vm.getEditURL()}},[_vm._v("\n      Edit this "+_vm._s(_vm.getModelTitle())+"\n    ")]):_vm._e(),(_vm.shouldAllowDelete() && !_vm.quickDelete)?_c('b-button',{attrs:{"type":"is-danger","icon-left":"trash","tag":"router-link","to":_vm.getDeleteURL()}},[_vm._v("\n      Delete this "+_vm._s(_vm.getModelTitle())+"\n    ")]):_vm._e(),(_vm.shouldAllowDelete() && _vm.quickDelete)?_c('b-button',{attrs:{"type":"is-danger","icon-left":"trash"},on:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v("\n      Delete this "+_vm._s(_vm.getModelTitle())+"\n    ")]):_vm._e()],1):_vm._e(),_vm._t("quick-entry"),(_vm.hasRows && _vm.mode == 'viewing')?_c('div',[(_vm.rowsTitle && _vm.shouldAllowCreateRow())?_c('div',{staticStyle:{"display":"flex"}},[_c('h2',{staticStyle:{"flex-grow":"1"}},[_vm._v(_vm._s(_vm.rowsTitle))]),_c('b-button',{attrs:{"type":"is-primary","tag":"router-link","to":_vm.getCreateRowButtonUrl(),"icon-left":"plus"}},[_vm._v("\n        "+_vm._s(_vm.createRowButtonText)+"\n      ")])],1):_vm._e(),(_vm.rowsTitle && !_vm.shouldAllowCreateRow())?_c('h2',[_vm._v("\n      "+_vm._s(_vm.rowsTitle)+"\n    ")]):_vm._e(),(_vm.shouldAllowCreateRow() && !_vm.rowsTitle)?_c('b-button',{attrs:{"type":"is-primary","tag":"router-link","to":_vm.getCreateRowButtonUrl(),"icon-left":"plus"}},[_vm._v("\n      "+_vm._s(_vm.createRowButtonText)+"\n    ")]):_vm._e(),_vm._t("row-filters"),_c('b-menu',[_c('b-menu-list',_vm._l((_vm.rowData.data),function(row){return _c('b-menu-item',{key:row.uuid,attrs:{"tag":"router-link","to":_vm.getRowRoute(row)},scopedSlots:_vm._u([{key:"label",fn:function(props){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.renderRowLabel(row))}})]}}],null,true)})}),1)],1),(_vm.rowsPaginated)?_c('b-pagination',{attrs:{"total":_vm.rowData.total,"current":_vm.rowPage,"per-page":_vm.rowsPerPage},on:{"update:current":function($event){_vm.rowPage=$event},"change":_vm.changeRowPagination}}):_vm._e()],2):_vm._e(),_vm._t("footer")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/model-crud/ByjoveModelCrud.vue?vue&type=template&id=7077082e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/model-crud/ByjoveModelCrud.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveModelCrudvue_type_script_lang_js_ = ({
    name: 'ByjoveModelCrud',
    props: {
        mode: String,
        modelName: String,
        modelSlug: String,
        modelTitle: String,
        modelTitlePlural: String,
        modelIndexTitle: String,
        modelPermissionPrefix: String,
        modelPathPrefix: String,
        modelRoutePrefix: String,
        apiIndexUrl: String,
        apiObjectUrl: String,
        labelRenderer: Function,
        parentHeaderLabelRenderer: Function,
        headerLabelRenderer: Function,
        rowLabelRenderer: Function,
        hasRows: {
            type: Boolean,
            default: false,
        },
        rowsTitle: {
            type: String,
            default: null,
        },
        allowCreateRow: {
            type: Boolean,
            default: false,
        },
        createRowPermission: {
            type: String,
            default: null,
        },
        createRowButtonText: {
            type: String,
            default: "Create New Row",
        },
        createRowButtonUrl: {
            type: String,
            default: null,
        },
        rowsPaginated: {
            type: Boolean,
            default: true,
        },
        rowsPerPage: {
            type: Number,
            default: 20,
        },
        rowRouteGetter: Function,
        apiRowsUrl: String,
        isRow: {
            type: Boolean,
            default: false,
        },
        rowPathPrefix: String,
        rowFilters: {
            type: Function,
            default: (uuid) => {
                return JSON.stringify([
                    {field: 'batch_uuid', op: 'eq', value: uuid},
                    {field: 'removed', op: 'eq', value: false},
                ])
            },
        },
        rowOrderBy: {
            type: String,
            default: 'modified',
        },
        rowOrderAscending: {
            type: Boolean,
            default: false,
        },
        allowEdit: {
            type: Boolean,
            default: true,
        },
        allowDelete: {
            type: Boolean,
            default: false,
        },
        quickDelete: {
            type: Boolean,
            default: false,
        },
        hideButtons: {
            type: Boolean,
            default: false,
        },
        hideSaveButton: {
            type: Boolean,
            default: false,
        },
        saveDisabled: {
            type: Boolean,
            default: false,
        },
        saveButtonText: {
            type: String,
            default: null,
        },
        saveButtonIcon: {
            type: String,
            default: null,
        },
        cancelUrl: {
            type: String,
            default: null,
        },
    },
    data: function() {
        return {
            record: {},
            rowData: {},
            rowPage: 1,
        }
    },

    computed: {
        showButtons: function() {
            if (this.hideButtons) {
                return false
            }
            if (this.mode == 'creating') {
                return true
            }
            if (this.mode == 'editing') {
                return true
            }
            if (this.mode == 'deleting') {
                return true
            }
            return false
        },
    },

    // TODO: why doesn't beforeRouteUpdate() work instead?
    // cf. https://router.vuejs.org/guide/essentials/dynamic-matching.html#reacting-to-params-changes
    watch: {
        '$route' (to, from) {
            if (to.name == (this.getModelRoutePrefix() + '.edit') && !this.hasModelPerm('edit')) {
                this.$buefy.toast.open({
                    message: "You do not have permission to access that page.",
                    type: 'is-danger',
                })
                this.$router.push(this.getModelPathPrefix() + '/')
            }

            // re-fetch record in case it was just changed
            if (to.name != (this.getModelRoutePrefix() + '.new')) {
                this.fetch(to.params.uuid)
            }
        },
    },

    // beforeRouteUpdate (to, from, next) {
    //     // re-fetch record in case it was just changed
    //     if (to.name != (this.getModelRoutePrefix() + '.new')) {
    //         this.fetch(to.params.uuid)
    //     }
    //     next()
    // },

    mounted() {

        // TODO: this seems like a "good" idea, but in practice, when reloading
        // the page/app via browser (Ctrl+Shift+R), the app must re-fetch the
        // session details before it knows which user/permissions are in
        // effect, and that takes "too long" which means these checks fail!

        // // redirect if user doesn't have permission to be here
        // if ((this.mode == 'viewing' && !this.hasModelPerm('view'))
        //     || (this.mode == 'creating' && !this.hasModelPerm('create'))
        //     || (this.mode == 'editing' && !this.hasModelPerm('edit'))
        //     || (this.mode == 'deleting' && !this.hasModelPerm('delete'))) {
        //     this.$buefy.toast.open({
        //         message: "You do not have permission to access that page.",
        //         type: 'is-danger',
        //     })
        //     this.$router.push(this.getModelPathPrefix() + '/')
        //     return
        // }

        // fetch initial page data unless 'creating'
        if (this.mode != 'creating') {
            this.fetch(this.$route.params.uuid)
        }
    },

    methods: {

        clear() {
            this.record = {}
            this.$emit('refresh', this.record)
        },

        getModelSlug() {
            if (this.modelSlug) {
                return this.modelSlug
            }
            return this.modelName.toLowerCase() + 's'
        },

        getModelTitle() {
            if (this.modelTitle) {
                return this.modelTitle
            }
            return this.modelName
        },

        getModelTitlePlural() {
            if (this.modelTitlePlural) {
                return this.modelTitlePlural
            }
            return this.getModelTitle() + 's'
        },

        getModelIndexTitle() {
            if (this.modelIndexTitle) {
                return this.modelIndexTitle
            }
            return this.getModelTitlePlural()
        },

        getModelPathPrefix() {
            if (this.modelPathPrefix) {
                return this.modelPathPrefix
            }
            return '/' + this.getModelSlug()
        },

        getModelRoutePrefix() {
            if (this.modelRoutePrefix) {
                return this.modelRoutePrefix
            }
            return this.getModelSlug()
        },

        getRowPathPrefix() {
            if (this.rowPathPrefix) {
                return this.rowPathPrefix
            }
            return '/' + this.getModelSlug() + '/rows'
        },

        getIndexURL() {
            return `${this.getModelPathPrefix()}/`
        },

        getParentUrl() {
            if (this.isRow) {
                return `${this.getModelPathPrefix()}/${this.record._parent_uuid}`
            }
        },

        getViewURL() {
            if (this.isRow) {
                return `${this.getRowPathPrefix()}/${this.record.uuid}`
            }
            return `${this.getModelPathPrefix()}/${this.record.uuid}`
        },

        getEditURL() {
            if (this.isRow) {
                return `${this.getRowPathPrefix()}/${this.record.uuid}/edit`
            }
            return `${this.getModelPathPrefix()}/${this.record.uuid}/edit`
        },

        getDeleteURL() {
            if (this.isRow) {
                return `${this.getRowPathPrefix()}/${this.record.uuid}/delete`
            }
            return `${this.getModelPathPrefix()}/${this.record.uuid}/delete`
        },

        getApiIndexUrl() {
            if (this.apiIndexUrl) {
                return this.apiIndexUrl
            }
            return '/api/' + this.getModelSlug()
        },

        getApiObjectUrlBase() {
            if (this.apiObjectUrl) {
                return this.apiObjectUrl
            }
            let url = this.getApiIndexUrl()
            // drop trailing 's' then add slash
            return url.slice(0, -1) + '/'
        },

        getApiObjectUrl(uuid) {
            let url = this.getApiObjectUrlBase()
            if (uuid) {
                url += uuid
            }
            return url
        },

        getApiRowsUrl() {
            return this.apiRowsUrl
        },

        getModelPermissionPrefix() {
            if (this.modelPermissionPrefix) {
                return this.modelPermissionPrefix
            }
            return this.getModelSlug()
        },

        hasModelPerm(perm) {

            // do normal check, but first add prefix
            let prefix = this.getModelPermissionPrefix()
            return this.$byjoveHasPerm(prefix + '.' + perm)
        },

        renderLabel(obj) {
            if (this.labelRenderer) {
                return this.labelRenderer(obj)
            }
            return obj._str
        },

        renderHeaderLabel(obj) {
            if (this.headerLabelRenderer) {
                return this.headerLabelRenderer(obj)
            }
            return this.renderLabel(obj)
        },

        renderParentHeaderLabel(obj) {
            if (this.parentHeaderLabelRenderer) {
                return this.parentHeaderLabelRenderer(obj)
            }
            return this.renderLabel(obj)
        },

        renderRowLabel(row) {
            if (this.rowLabelRenderer) {
                return this.rowLabelRenderer(row)
            }
            return row._str
        },

        getSaveButtonIcon() {
            if (this.saveButtonIcon) {
                return this.saveButtonIcon
            }
            if (this.mode == 'deleting') {
                return 'trash'
            }
            return 'save'
        },

        getSaveButtonText() {
            if (this.saveButtonText) {
                return this.saveButtonText
            }
            if (this.mode == 'deleting') {
                return "Delete This Forever!"
            }
            if (this.mode == 'creating') {
                return `Create ${this.getModelTitle()}`
            }
            return "Save Data"
        },

        getSaveButtonType() {
            if (this.mode == 'deleting') {
                return 'is-danger'
            }
            return 'is-primary'
        },

        fetch(uuid) {
            this.$http.get(this.getApiObjectUrl(uuid)).then(response => {
                this.record = response.data.data
                this.$emit('refresh', this.record)
                if (this.hasRows) {
                    this.fetchRows(uuid)
                }
            }, response => {
                if (response.status == 403) { // forbidden
                    this.$buefy.toast.open({
                        message: "You do not have permission to access that page.",
                        type: 'is-danger',
                    })
                } else if (response.status == 404) { // notfound
                    this.$buefy.toast.open({
                        message: `The requested ${this.getModelTitle()} was not found.`,
                        type: 'is-danger',
                    })
                } else { // other error
                    this.$buefy.toast.open({
                        message: "Failed to fetch page data!",
                        type: 'is-danger',
                    })
                }
                // redirect to model index
                this.$router.push(this.getIndexURL())
            })

        },

        fetchRows(uuid) {
            let params = {
                filters: this.rowFilters(uuid),
                orderBy: this.rowOrderBy,
                ascending: this.rowOrderAscending ? 1 : 0,
            }
            if (this.rowsPaginated) {
                params.per_page = this.rowsPerPage
                params.page = this.rowPage
            }
            this.$http.get(this.getApiRowsUrl(), {params: params}).then(response => {
                this.rowData = response.data
                // TODO: for some reason rowPage is getting reset to 0, maybe by
                // the b-pagination component?  for now this is our workaround
                if (!this.rowPage) {
                    this.rowPage = 1
                }
            }, response => {
                if (response.status == 403) { // forbidden; redirect to home page
                    this.$buefy.toast.open({
                        message: "You do not have permission to access that page.",
                        type: 'is-danger',
                    })
                    this.$router.push('/')
                } else {
                    this.$buefy.toast.open({
                        message: "Failed to fetch page data!",
                        type: 'is-danger',
                    })
                }
            })
        },

        getRowRoute(row) {
            if (this.rowRouteGetter) {
                return this.rowRouteGetter(row)
            }
            return this.getRowPathPrefix() + '/' + row.uuid
        },

        changeRowPagination(value) {
            this.fetchRows(this.record.uuid)
        },

        shouldAllowEdit() {
            if (!this.allowEdit) {
                return false
            }
            if (this.mode != 'viewing') {
                return false
            }
            if (!this.hasModelPerm('edit')) {
                return false
            }
            return true
        },

        shouldAllowDelete() {
            if (!this.allowDelete) {
                return false
            }
            if (this.mode != 'viewing') {
                return false
            }
            if (!this.hasModelPerm('delete')) {
                return false
            }
            return true
        },

        getCancelURL() {
            if (this.cancelUrl) {
                return this.cancelUrl
            }
            if (this.mode == 'creating') {
                return this.getIndexURL()
            }
            return this.getViewURL()
        },

        save() {
            if (this.mode == 'deleting') {
                this.confirmDelete()
                return
            }

            let url
            if (this.mode == 'creating') {
                url = this.getApiIndexUrl()
            } else {
                url = this.getApiObjectUrl(this.record.uuid)
            }
            this.$emit('save', url)
        },

        confirmDelete() {
            let modelTitle = this.getModelTitle()
            this.$buefy.dialog.confirm({
                title: `Delete ${modelTitle}`,
                message: `Are you sure you wish to delete this ${modelTitle}?`,
                hasIcon: true,
                type: 'is-danger',
                confirmText: `Delete ${modelTitle}`,
                cancelText: "Whoops, nevermind",
                onConfirm: this.deleteObject,
            })
        },

        deleteObject() {
            let url = this.getApiObjectUrl(this.record.uuid)
            this.$http.delete(url).then(response => {
                if (this.isRow) {
                    this.$router.push(this.getParentUrl())
                } else {
                    this.$router.push(this.getIndexURL())
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "Failed to delete the record!",
                    type: 'is-danger',
                })
            })
        },

        shouldAllowCreateRow() {
            if (!this.allowCreateRow) {
                return false
            }
            if (this.mode != 'viewing') {
                return false
            }
            if (this.createRowPermission) {
                if (!this.$byjoveHasPerm(this.createRowPermission)) {
                    return false
                }
            } else {
                if (!this.hasModelPerm('create_row')) {
                    return false
                }
            }
            return true
        },

        getCreateRowButtonUrl() {
            if (this.createRowButtonUrl) {
                return this.createRowButtonUrl
            }
            return this.getApiRowsUrl()
        },
    },
});

// CONCATENATED MODULE: ./src/components/model-crud/ByjoveModelCrud.vue?vue&type=script&lang=js&
 /* harmony default export */ var model_crud_ByjoveModelCrudvue_type_script_lang_js_ = (ByjoveModelCrudvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/model-crud/ByjoveModelCrud.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  model_crud_ByjoveModelCrudvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveModelCrud = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "62bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveInventory_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3f64");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveInventory', _ByjoveInventory_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveInventory_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "65c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/products/ByjoveProducts.vue?vue&type=template&id=02324980&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('byjove-model-index',{attrs:{"model-name":"Product","want-initial-results":_vm.wantInitialResults,"allow-create":_vm.allowCreate}},[_c('byjove-scanner-input',{on:{"submit":_vm.scannerSubmit}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/products/ByjoveProducts.vue?vue&type=template&id=02324980&

// EXTERNAL MODULE: ./src/components/model-index/index.js
var model_index = __webpack_require__("4945");

// EXTERNAL MODULE: ./src/components/scanner-input/index.js
var scanner_input = __webpack_require__("1f02");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/products/ByjoveProducts.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ByjoveProductsvue_type_script_lang_js_ = ({
    name: 'ByjoveProducts',
    components: {
        ByjoveModelIndex: model_index["a" /* default */],
        ByjoveScannerInput: scanner_input["a" /* default */],
    },
    props: {
        wantInitialResults: {
            type: Boolean,
            default: false,
        },
        allowCreate: {
            type: Boolean,
            default: false,
        },
    },
    methods: {

        scannerSubmit(entry) {
            let url = '/api/products/quick-lookup'
            let params = {entry: entry}
            this.$http.get(url, {params: params}).then(response => {
                if (response.data.error) {
                    this.$buefy.toast.open({
                        message: response.data.error,
                        type: 'is-danger',
                    })
                } else {
                    this.$router.push(`/products/${response.data.product.uuid}`)
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "Unknown error!",
                    type: 'is-danger',
                })
            })
        },
    },
});

// CONCATENATED MODULE: ./src/components/products/ByjoveProducts.vue?vue&type=script&lang=js&
 /* harmony default export */ var products_ByjoveProductsvue_type_script_lang_js_ = (ByjoveProductsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/products/ByjoveProducts.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  products_ByjoveProductsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveProducts = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "700d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveReceiving_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7ed4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveReceiving_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveReceiving_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveReceiving_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7d4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveModelIndex_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("418e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveModelIndex_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveModelIndex_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveModelIndex_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7ed4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "934a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveLogo_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("20b1");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveLogo', _ByjoveLogo_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveLogo_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "955f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveMenu_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("17d7");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveMenu', _ByjoveMenu_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveMenu_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "a84d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/products/ByjoveProduct.vue?vue&type=template&id=359de3ce&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('byjove-model-crud',{directives:[{name:"show",rawName:"v-show",value:(!_vm.scannerSubmitting),expression:"!scannerSubmitting"}],ref:"modelCrud",staticClass:"block",attrs:{"model-name":"Product","label-renderer":_vm.renderLabel,"allow-edit":_vm.allowEdit,"mode":_vm.mode},on:{"refresh":function (record) { _vm.product = record }}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","margin-bottom":"0.5rem"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('b-field',{attrs:{"label":"Brand"}},[_vm._v("\n          "+_vm._s(_vm.product.brand_name)+"\n        ")]),_c('b-field',{attrs:{"label":"Description"}},[_vm._v("\n          "+_vm._s(_vm.product.description)+"\n        ")]),_c('b-field',{attrs:{"label":"Size"}},[_vm._v("\n          "+_vm._s(_vm.product.size)+"\n        ")])],1),_c('img',{attrs:{"src":_vm.product.image_url}})]),_vm._t("default-panels",function(){return [_c('b-collapse',{staticClass:"card",attrs:{"animation":"slide","open":false,"aria-id":"contentIdForVendors"},scopedSlots:_vm._u([{key:"trigger",fn:function(props){return [_c('div',{staticClass:"card-header",attrs:{"role":"button","aria-controls":"contentIdForVendors","aria-expanded":props.open}},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n              Vendors\n            ")]),_c('a',{staticClass:"card-header-icon"},[_c('b-icon',{attrs:{"pack":"fas","icon":props.open ? 'angle-up' : 'angle-down'}})],1)])]}}])},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('b-field',{attrs:{"label":"Preferred"}},[_vm._v("\n              "+_vm._s(_vm.product.vendor_name)+" @ "+_vm._s(_vm.product.default_unit_cost_display)+"\n            ")]),_c('b-table',{attrs:{"data":_vm.product.costs}},[_c('b-table-column',{attrs:{"label":"Vendor","field":"vendor_name"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.vendor_name)+"\n              ")]}}])}),_c('b-table-column',{attrs:{"label":"Unit Cost","field":"unit_cost"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.unit_cost)+"\n              ")]}}])})],1)],1)])]),_c('b-collapse',{staticClass:"card",attrs:{"animation":"slide","open":false,"aria-id":"contentIdForPrices"},scopedSlots:_vm._u([{key:"trigger",fn:function(props){return [_c('div',{staticClass:"card-header",attrs:{"role":"button","aria-controls":"contentIdForPrices","aria-expanded":props.open}},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n              Prices\n            ")]),_c('a',{staticClass:"card-header-icon"},[_c('b-icon',{attrs:{"pack":"fas","icon":props.open ? 'angle-up' : 'angle-down'}})],1)])]}}])},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('b-field',{attrs:{"label":"Reg. Price"}},[_vm._v("\n              "+_vm._s(_vm.product.unit_price_display)+"\n            ")]),(_vm.product.sale_price)?_c('b-field',{attrs:{"label":"Sale Price"}},[_vm._v("\n              "+_vm._s(_vm.product.sale_price_display)+"\n            ")]):_vm._e(),(_vm.product.sale_price)?_c('b-field',{attrs:{"label":"Sale Ends"}},[_vm._v("\n              "+_vm._s(_vm.product.sale_ends_display)+"\n            ")]):_vm._e(),(_vm.product.tpr_price)?_c('b-field',{attrs:{"label":"TPR Price"}},[_vm._v("\n              "+_vm._s(_vm.product.tpr_price_display)+"\n            ")]):_vm._e(),(_vm.product.tpr_price)?_c('b-field',{attrs:{"label":"TPR Ends"}},[_vm._v("\n              "+_vm._s(_vm.product.tpr_ends_display)+"\n            ")]):_vm._e()],1)])])]},{"product":_vm.product}),_vm._t("extra-panels",null,{"product":_vm.product})],2),_c('byjove-scanner-input',{ref:"scannerInput",staticClass:"block",on:{"submit":_vm.scannerSubmit}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/products/ByjoveProduct.vue?vue&type=template&id=359de3ce&

// EXTERNAL MODULE: ./src/components/model-crud/index.js
var model_crud = __webpack_require__("22a1");

// EXTERNAL MODULE: ./src/components/scanner-input/index.js
var scanner_input = __webpack_require__("1f02");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/products/ByjoveProduct.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ByjoveProductvue_type_script_lang_js_ = ({
    name: 'Product',
    props: {
        mode: String,
        allowEdit: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ByjoveModelCrud: model_crud["a" /* default */],
        ByjoveScannerInput: scanner_input["a" /* default */],
    },
    data: function() {
        return {
            product: {},
            scannerSubmitting: false,
        }
    },
    methods: {
        renderLabel(product) {
            return product.product_key
        },

        scannerSubmit(entry) {
            this.scannerSubmitting = true
            let url = '/api/products/quick-lookup'
            let params = {entry: entry}
            this.$http.get(url, {params: params}).then(response => {
                if (response.data.error) {
                    this.$buefy.toast.open({
                        message: response.data.error,
                        type: 'is-danger',
                    })
                } else {
                    this.$refs.scannerInput.clear()
                    this.$refs.modelCrud.clear()
                    this.$router.push(`/products/${response.data.product.uuid}`)
                }
                this.scannerSubmitting = false
            }, response => {
                this.$buefy.toast.open({
                    message: "Unknown error!",
                    type: 'is-danger',
                })
                this.scannerSubmitting = false
            })
        },

    },
});

// CONCATENATED MODULE: ./src/components/products/ByjoveProduct.vue?vue&type=script&lang=js&
 /* harmony default export */ var products_ByjoveProductvue_type_script_lang_js_ = (ByjoveProductvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/products/ByjoveProduct.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  products_ByjoveProductvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveProduct = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "ae81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveLogo_vue_vue_type_style_index_0_id_219f645c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e903");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveLogo_vue_vue_type_style_index_0_id_219f645c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveLogo_vue_vue_type_style_index_0_id_219f645c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_index_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ByjoveLogo_vue_vue_type_style_index_0_id_219f645c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b7e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveProducts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("65c1");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _ByjoveProducts__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _ByjoveProduct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a84d");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _ByjoveProduct__WEBPACK_IMPORTED_MODULE_1__["a"]; });




// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveProducts', _ByjoveProducts__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
    Vue.component('ByjoveProduct', _ByjoveProduct__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}




/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "cf05":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.82b9c7a5.png";

/***/ }),

/***/ "e6f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveReceiving_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0307");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveReceiving', _ByjoveReceiving_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveReceiving_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "e903":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ec50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"68f36aea-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/home/ByjoveHome.vue?vue&type=template&id=cde64e74&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered"},[_c('img',{attrs:{"alt":((_vm.appsettings.systemTitle) + " logo"),"src":_vm.appsettings.logo}}),_c('h1',[_vm._v("Welcome to "+_vm._s(_vm.appsettings.appTitle))])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/home/ByjoveHome.vue?vue&type=template&id=cde64e74&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/home/ByjoveHome.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var ByjoveHomevue_type_script_lang_js_ = ({
    name: 'ByjoveHome',
    props: {
        appsettings: {
            type: Object,
        },
        forceLogin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            inited: false,
        }
    },
    created() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {
        init() {
            if (this.inited) return

            // nothing to check, unless login is to be enforced
            if (!this.forceLogin) {
                this.inited = true
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            this.inited = true

            // send anonymous users to login page
            if (!this.$store.state.user.uuid) {
                this.$router.push('/login')
            }
        },
    },
});

// CONCATENATED MODULE: ./src/components/home/ByjoveHome.vue?vue&type=script&lang=js&
 /* harmony default export */ var home_ByjoveHomevue_type_script_lang_js_ = (ByjoveHomevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/home/ByjoveHome.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  home_ByjoveHomevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ByjoveHome = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "f256":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony import */ var _ByjoveApp_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("04d0");
// Import vue component


// Declare install function executed by Vue.use()
function install(Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('ByjoveApp', _ByjoveApp_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
    install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
}
if (GlobalVue) {
    GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_ByjoveApp_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./src/plugin.js

function ByjovePlugin(Vue) {
    Vue.mixin({
        methods: {

            $byjoveLoginUser(user, permissions) {

                // put user info in app store
                this.$store.commit('SET_USER', user)
                this.$store.commit('SET_USER_IS_ADMIN', user.is_admin)
                // note, this should already be false
                // this.$store.commit('SET_USER_IS_ROOT', false)

                // maybe update permissions
                if (permissions !== undefined) {
                    this.$store.commit('SET_PERMISSIONS', permissions)
                }
            },

            // TODO: deprecate / remove
            $loginUser(user, permission) {
                this.$byjoveLoginUser(user, permission)
            },

            $byjoveLogoutUser() {

                // remove user info from app store
                this.$store.commit('SET_USER', {})
                this.$store.commit('SET_USER_IS_ADMIN', false)
                this.$store.commit('SET_USER_IS_ROOT', false)
            },

            // TODO: deprecate / remove
            $logoutUser() {
                this.$byjoveLogoutUser()
            },

            $byjoveHasPerm(name) {

                // if user is root then assume permission
                if (this.$store.state.user_is_root) {
                    return true
                }

                // otherwise do true perm check for user
                return this.$store.state.permissions.includes(name)
            },

            // TODO: deprecate / remove
            $hasPerm(name) {
                return this.$byjoveHasPerm(name)
            },
        }
    })

    Vue.filter('byjoveCurrency', function (value) {
        if (typeof value !== 'number') {
            return value
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            // TODO: make this configurable?
            minimumFractionDigits: 2,
        })
        return formatter.format(value)
    })
}

// EXTERNAL MODULE: ./src/components/app/index.js
var app = __webpack_require__("f256");

// EXTERNAL MODULE: ./src/components/menu/index.js
var menu = __webpack_require__("955f");

// EXTERNAL MODULE: ./src/components/home/index.js
var home = __webpack_require__("10dd");

// EXTERNAL MODULE: ./src/components/logo/index.js
var logo = __webpack_require__("934a");

// EXTERNAL MODULE: ./src/components/feedback/index.js
var feedback = __webpack_require__("4275");

// EXTERNAL MODULE: ./src/components/login/index.js
var login = __webpack_require__("4395");

// EXTERNAL MODULE: ./src/components/autocomplete/index.js
var autocomplete = __webpack_require__("00e4");

// EXTERNAL MODULE: ./src/components/model-index/index.js
var model_index = __webpack_require__("4945");

// EXTERNAL MODULE: ./src/components/model-crud/index.js
var model_crud = __webpack_require__("22a1");

// EXTERNAL MODULE: ./src/components/scanner-input/index.js
var scanner_input = __webpack_require__("1f02");

// EXTERNAL MODULE: ./src/components/products/index.js
var products = __webpack_require__("b7e7");

// EXTERNAL MODULE: ./src/components/customers/index.js
var customers = __webpack_require__("0010");

// EXTERNAL MODULE: ./src/components/inventory/index.js
var inventory = __webpack_require__("62bd");

// EXTERNAL MODULE: ./src/components/receiving/index.js
var receiving = __webpack_require__("e6f9");

// CONCATENATED MODULE: ./src/components/index.js

















// CONCATENATED MODULE: ./src/store.js

let ByjoveStoreConfig = {
    state: {
        session_established: false,
        user: {},
        user_is_admin: false,
        user_is_root: false,
        permissions: [],
        settings: {},
    },
    mutations: {
        SET_SESSION_ESTABLISHED(state, established) {
            state.session_established = established
        },
        SET_USER(state, user) {
            state.user = user
        },
        SET_USER_IS_ADMIN(state, is_admin) {
            state.user_is_admin = is_admin
        },
        SET_USER_IS_ROOT(state, is_root) {
            state.user_is_root = is_root
        },
        SET_PERMISSIONS(state, permissions) {
            state.permissions = permissions
        },
        SET_SETTINGS(state, settings) {
            state.settings = settings
        },
    },
    actions: {
        // TODO: should we define the logic here, for fetching current session
        // from backend API?  (thus far that happens in App.mount() instead)
    },
}

// CONCATENATED MODULE: ./src/index.js






/* harmony default export */ var src = ({});

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport ByjoveStoreConfig */__webpack_require__.d(__webpack_exports__, "ByjoveStoreConfig", function() { return ByjoveStoreConfig; });
/* concated harmony reexport ByjovePlugin */__webpack_require__.d(__webpack_exports__, "ByjovePlugin", function() { return ByjovePlugin; });
/* concated harmony reexport ByjoveApp */__webpack_require__.d(__webpack_exports__, "ByjoveApp", function() { return app["a" /* default */]; });
/* concated harmony reexport ByjoveMenu */__webpack_require__.d(__webpack_exports__, "ByjoveMenu", function() { return menu["a" /* default */]; });
/* concated harmony reexport ByjoveHome */__webpack_require__.d(__webpack_exports__, "ByjoveHome", function() { return home["a" /* default */]; });
/* concated harmony reexport ByjoveLogo */__webpack_require__.d(__webpack_exports__, "ByjoveLogo", function() { return logo["a" /* default */]; });
/* concated harmony reexport ByjoveFeedback */__webpack_require__.d(__webpack_exports__, "ByjoveFeedback", function() { return feedback["a" /* default */]; });
/* concated harmony reexport ByjoveLogin */__webpack_require__.d(__webpack_exports__, "ByjoveLogin", function() { return login["a" /* default */]; });
/* concated harmony reexport ByjoveAutocomplete */__webpack_require__.d(__webpack_exports__, "ByjoveAutocomplete", function() { return autocomplete["a" /* default */]; });
/* concated harmony reexport ByjoveModelIndex */__webpack_require__.d(__webpack_exports__, "ByjoveModelIndex", function() { return model_index["a" /* default */]; });
/* concated harmony reexport ByjoveModelCrud */__webpack_require__.d(__webpack_exports__, "ByjoveModelCrud", function() { return model_crud["a" /* default */]; });
/* concated harmony reexport ByjoveScannerInput */__webpack_require__.d(__webpack_exports__, "ByjoveScannerInput", function() { return scanner_input["a" /* default */]; });
/* concated harmony reexport ByjoveProducts */__webpack_require__.d(__webpack_exports__, "ByjoveProducts", function() { return products["b" /* ByjoveProducts */]; });
/* concated harmony reexport ByjoveProduct */__webpack_require__.d(__webpack_exports__, "ByjoveProduct", function() { return products["a" /* ByjoveProduct */]; });
/* concated harmony reexport ByjoveCustomerField */__webpack_require__.d(__webpack_exports__, "ByjoveCustomerField", function() { return customers["a" /* default */]; });
/* concated harmony reexport ByjoveInventory */__webpack_require__.d(__webpack_exports__, "ByjoveInventory", function() { return inventory["a" /* default */]; });
/* concated harmony reexport ByjoveReceiving */__webpack_require__.d(__webpack_exports__, "ByjoveReceiving", function() { return receiving["a" /* default */]; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ })

/******/ });
});
//# sourceMappingURL=byjove.umd.js.map